<template>
  <div class="w-full flex-grow">
    <div
      v-for="(fields, index) of normalizedFields"
      :key="index"
      class="flex w-full"
    >
      <template v-for="field of fields">
        <DynamicLayoutField
          v-if="field.type === 'question' || field.type === 'custom'"
          :key="field.id"
          :data-test="field.id"
          class="mb-3"
          :question-id="field.id"
          :questions="questions"
          :document-value="documentValue"
          :value="value"
          :path="path"
        />
        <div
          v-if="shouldRenderCard(field)"
          :key="field.id"
          :data-test="field.id"
          v-bind="field.config"
          :node="field"
          class="flex-grow d-flex flex-col w-full py-4"
        >
          <h2
            style="margin-top: 1rem !important"
            class="text-xl font-bold mb-2"
          >{{ field.config.title }}</h2>
          <DynamicLayoutWrapper
            :template="field.children"
            :questions="questions"
            :document-value="documentValue"
            :value="value"
            :is-nested="true"
            :path="path"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { toRefs } from '@nuxtjs/composition-api'
import DynamicLayoutField from './DynamicLayoutField'
import { anyCardItemVisible } from '@/utils/generalUtils'
import useFeatureFlags from '@/composables/useFeatureFlags'
import { HIDE_EMPTY_CARDS } from '@/constants/featureFlags'

function unwrapRows(field) {
  if (Array.isArray(field)) return field
  else {
    if (field.type === 'row') {
      return field.children
    }
    return field
  }
}
export default {
  name: 'DynamicLayoutWrapper',
  components: { DynamicLayoutField },
  props: {
    template: {
      type: Array,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
    documentValue: {
      type: Object,
      required: true,
    },
    // eslint-disable-next-line
    value: {
      required: true,
    },
    columns: {
      type: [Number, String],
      default: 'auto',
    },
    path: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const { questions, documentValue } = toRefs(props)
    const { hideEmptyCards } = useFeatureFlags({
      hideEmptyCards: HIDE_EMPTY_CARDS,
    })
    const anyChildVisible = anyCardItemVisible(
      questions.value,
      documentValue.value
    )

    function shouldRenderCard(field) {
      return hideEmptyCards
        ? field.type === 'card' && anyChildVisible(field.children)
        : field.type === 'card'
    }

    return {
      shouldRenderCard,
    }
  },
  computed: {
    normalizedFields() {
      const unwrappedFields = this.template.map(unwrapRows)

      if (this.columns === 'auto' || this.columns === 1) {
        return unwrappedFields.map(
          (fields) => (Array.isArray(fields) ? fields : [fields])
        )
      } else {
        const rowsLength = Math.ceil(unwrappedFields.length / this.columns)
        return new Array(rowsLength)
          .fill()
          .map((el, index) =>
            unwrappedFields.slice(
              index * this.columns,
              index * this.columns + this.columns
            )
          )
      }
    },
  },
}
</script>
